// extracted by mini-css-extract-plugin
module.exports = {"container":"ClientAuthContainer_container__ZHYos"};